import React, { useEffect, useState } from "react"
import latlongtokm from "@riskyvaibhav/lat-long-to-km"
import { Loader } from "google-maps"
import { useDebounce } from "use-debounce"

import { Taxonomy } from "./Filter"
import { Filters } from "./App"

interface CheckboxLocationProps {
    taxonomy: Taxonomy
    onChange: (
        type: "checkbox" | "select" | "checkbox-location-based",
        key: string,
        termId: number
    ) => void
    filters: Filters
    filtersKey: string
    onTaxonomyKmUpdate: (taxonomy: Taxonomy) => void
}

export default function CheckboxLocation({
    taxonomy,
    onChange,
    filters,
    filtersKey,
    onTaxonomyKmUpdate,
}: CheckboxLocationProps) {
    const [zipcode, setZipcode] = useState("")
    const [message, setMessage] = useState("")
    const [value] = useDebounce(zipcode, 1000)
    const [isLoading, setLoading] = useState(false)

    function fetchGeolocation() {
        const service = new window.google.maps.Geocoder()

        return new Promise((resolve, reject) => {
            service.geocode(
                {
                    address: `${zipcode}, Nederland`,
                },
                (response, status) => {
                    if (status === "OK") {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }
            )
        })
    }

    useEffect(() => {
        if (value === "") {
            setLoading(false)
            setMessage("")
            return
        }
        if (
            new RegExp(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i).test(value) ===
            false
        ) {
            setMessage("Postcode is ongeldig")
            setLoading(false)
            return
        }

        setMessage("")
        setLoading(true)
        fetchGeolocation().then((response) => {
            const results = response[0]

            taxonomy.items = taxonomy.items.map((item) => {
                if (!item.hq?.latitude) return item
                const km = latlongtokm(
                    item.hq.latitude,
                    item.hq.longitude,
                    results.geometry.location.lat(),
                    results.geometry.location.lng()
                )
                item.km = km.toFixed(0)
                return item
            })

            taxonomy.items = taxonomy.items.sort((a, b) => {
                return a.km - b.km
            })

            onTaxonomyKmUpdate(taxonomy)
            setLoading(false)
        })
    }, [value])

    useEffect(() => {
        const loader = new Loader("AIzaSyBzq4Ixboz3rLpxFuYL3Dia1OtbPtruQg0")
        loader.load().then((google) => {
            window.google = google
        })
    }, [])

    return (
        <div className="taxonomy mb-5 last:mb-0 text-[#8C8C8C]">
            <label htmlFor="zipcode" className="mb-4 block">
                <strong className="mb-1 block">Sorteer leveranciers</strong>
                <input
                    className="w-full text-sm py-1 px-3"
                    type="text"
                    name="zipcode"
                    defaultValue={zipcode}
                    placeholder="Postcode"
                    onChange={(e) => setZipcode(e.target.value)}
                />

                {message && (
                    <span className="block mt-2 text-[tomato]">{message}</span>
                )}
            </label>

            <strong className="taxonomy-label block mb-2">
                {taxonomy.label}
            </strong>
            <div className="taxonomy-list flex flex-col gap-y-1 max-h-[155px] overflow-scroll">
                {isLoading ? (
                    <span>Laden...</span>
                ) : (
                    taxonomy.items.map((item) => (
                        <label
                            className="flex items-center select-none cursor-pointer mb-1"
                            key={item.term_id}
                            onClick={() =>
                                onChange("checkbox", filtersKey, item.term_id)
                            }
                        >
                            {filters[filtersKey].includes(item.term_id) ? (
                                <div className="w-[18px] h-[18px] border border-primary bg-primary rounded mr-3" />
                            ) : (
                                <div className="w-[18px] h-[18px] border border-[#b6b6b6] rounded mr-3" />
                            )}
                            <span className="block leading-none mt-[1px]">
                                {item.name}{" "}
                                {item?.km ? `(${item.km} km)` : null}
                            </span>
                        </label>
                    ))
                )}
            </div>
        </div>
    )
}
